import { FinishMatchModal } from "./FinishMatchModal"
import { MatchEffectsModal } from "./MatchEffectsModal"
import { MatchGoldCards } from "./MatchGoldCards"
import { MatchLogsModal } from "./MatchLogsModal"
import { MatchPlayerModal } from "./MatchPlayerModal"
import { MatchSettingsModal } from "./MatchSettingsModal"
import { MatchSurrenderModal } from "./MatchSurrenderModal"

export const MATCH_MODALS = {
  finishMatch: {
    component: FinishMatchModal
  },
  matchLogs: {
    component: MatchLogsModal
  },
  matchSettings: {
    component: MatchSettingsModal
  },
  matchSurrender: {
    component: MatchSurrenderModal,
    params: {} as {
      onBack?: () => void
    }
  },
  matchEffects: {
    component: MatchEffectsModal,
    params: {} as {
      playerId: string
    }
  },
  matchGoldCards: {
    component: MatchGoldCards
  },
  matchPlayer: {
    component: MatchPlayerModal,
    params: {} as {
      playerId: string
    }
  }
} as const
